import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { Field, SelectInput } from '@hb/coffee';
import DictApi from '@/api/dict';
import { OptionItem } from '@/model/OptionItem';
import { SupplementInfoField } from '@/components/supplement-info-fields/types';
import { isEmptyFieldValue } from '../../utils';

@Component({ name: 'Role' })
export default class Role extends Vue implements SupplementInfoField {
  @Prop()
  private value!: undefined | number;

  private role: undefined | number | null = null;

  private errorMsg = '';

  private options: OptionItem[] = [];

  private async created() {
    if (this.value) {
      this.role = this.value;
    }

    this.options = await DictApi.getWorkType();
  }

  @Watch('value')
  private onPropsValueChange(val: undefined | number) {
    this.role = val;
  }

  public onValidator(): boolean {
    if (isEmptyFieldValue(this.role)) {
      this.errorMsg = '请选择工作性质';
      return false;
    }

    this.errorMsg = '';
    return true;
  }

  private onChangeRole(val: number | undefined | null) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private render() {
    return (
      <Field
        label="工作性质"
        errorMessage={this.errorMsg}
        >
        <SelectInput
          v-model={this.role}
          title="选择工作性质"
          placeholder="选择工作性质"
          options={this.options}
          optionFieldNames={{
            key: 'code',
            value: 'name',
          }}
          onChange={this.onChangeRole}
        />
      </Field>
    );
  }
}
